import { EventOffer, EventOfferCreateReqType } from 'types/promoters/promoterTypes';

export enum CREATE_EVENT_OFFER_PAGE_ENUM {
  PER_SHOW = 'PER_SHOW',
  PER_MULTIPLE_NUMBER_OF_TICKETS = 'PER_MULTIPLE_NUMBER_OF_TICKETS',
  PER_FIXED_PERCENTAGE_DISCOUNT = 'PER_FIXED_PERCENTAGE_DISCOUNT',
  GREATER_OR_EQUAL_TICKETS = 'GREATER_OR_EQUAL_TICKETS',
  FIXED_PRICE_ON_EACH_TICKET_TYPE = 'FIXED_PRICE_ON_EACH_TICKET_TYPE',
  FIXED_PRICE_ON_SPECIFIC_TYPES = 'FIXED_PRICE_ON_SPECIFIC_TYPES',
  PER_DIFFERENT_EVENT = 'PER_DIFFERENT_EVENT',
}

export function transformToEventOfferCreateReqType(offer: EventOffer): EventOfferCreateReqType {
  return {
    id: offer.id,
    name: offer.name,
    eventId: offer.eventId,
    description: offer.description,
    dateFrom: offer.dateFrom,
    dateTo: offer.dateTo,
    active: offer.active,
    numberOfTicketsAvailable: offer.numberOfTicketsAvailable,
    fixedDiscount: offer.fixedDiscount,
    numberOfTicketsToGetDiscount: offer.numberOfTicketsToGetDiscount,
    numberOfTicketsToGetDiscountOn: offer.numberOfTicketsToGetDiscountOn,
    fixedDiscountValueType: offer.fixedDiscountValueType,
    minimumNumberOfShows: offer.minimumNumberOfShows,
    offerType: offer.offerType,
    showRestrictions: offer.restrictToShows?.map((show) => ({
      showId: show.showId,
    })),
    eventLinks: offer.eventLinks?.map((link) => ({
      eventId: link.eventId,
    })),
    ticketTypes: offer.ticketTypes?.map((ticket) => ({
      ticketTypeId: ticket.ticketTypeId ?? ticket.ticketType.id,
      newPrice: ticket.priceToBeSold,
      minimumNumberOfTickets: ticket.minimumNumberOfTicketsToBeBought,
    })),
  };
}
